/* eslint-disable eqeqeq */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-await-in-loop */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useRef } from 'react';
import useApi from 'hooks/useApi';
import axios from 'axios';
import PropTypes from 'prop-types';
import { ReactComponent as DownloadIcon } from 'assets/icon-download.svg';
import { ReactComponent as UploadIcon } from 'assets/icon-up-file.svg';
import { ReactComponent as SendIcon } from 'assets/icon-send.svg';
import { ReactComponent as ContactsIcon } from 'assets/icon-contacts.svg';
import { ReactComponent as ErrorIcon } from 'assets/icon-close-round.svg';
import { ReactComponent as ValidIcon } from 'assets/icon-check-round.svg';
import { ReactComponent as UserIcon } from 'assets/icon-user.svg';
import Scrollbars from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';
import { Button } from 'shared/components/Buttons';
import AlertModal from 'shared/components/AlertModal';
import MainSpinner from 'shared/components/MainSpinner';
import { useTranslation } from 'react-i18next';
import { LabelError } from 'shared/components/Labels';
import { colors } from 'shared/defaultTheme';
import * as XLSX from 'xlsx';
import { useSelector } from 'react-redux';

const ContactsImportModal = ({ onCloseContactsImportModal }) => {
  const { cusNavId, mail, authToken } = useSelector((state) => state.auth);
  const { t } = useTranslation();
  const { customAreaApi } = useApi();
  const [showSuccessDownloadTemplate, setShowSuccessDownloadTemplate] = useState(false);
  const [onUploadingFile, setOnUploadingFile] = useState(false);
  const [onValidation, setOnValidation] = useState(false);
  const [error, setError] = useState('');
  const [file, setFile] = useState(null);
  const [parsedData, setParsedData] = useState([]);
  const [errors, setErrors] = useState([]);
  const [errorsInfo, setErrorsInfo] = useState(false);
  const [selectedFileName, setSelectedFileName] = useState('');
  const [showSuccessContactsData, setShowSuccessContactsData] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSuccessImportContactsData, setShowSuccessImportContactsData] = useState(false);
  const [showErrorImportContactsData, setShowErrorImportContactsData] = useState(false);
  const [showErrorInvalidData, setShowErrorInvalidData] = useState(false);

  const allowedExtensions = ['xlsx'];
  const inputFileValue = useRef(null);

  const [{ loading }, getContactsData] = customAreaApi(
    {
      url: `${window.API_V1}/cli/clients/${cusNavId}/export?login=${encodeURIComponent(mail)}`,
      method: 'GET',
      encoding: 'UTF-8',
      responseType: 'blob',
    },
    { manual: true }
  );

  const onDownloadTemplate = async () => {
    try {
      const response = await axios.get(
        'https://content.lefebvreelderecho.com/getFile.aspx?data=ZmlsZU5hbWU9UGxhbnRpbGxhX2NhcmdhX2NvbnRhY3Rvcy54bHN4JmFyZWE9bWFudWFsZXMmc3ViRm9sZGVyPXBvcnRhbGNsaWVudGVz',
        {
          responseType: 'blob',
        }
      );
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/octect-stream' })
      );
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Contacts_template.xlsx';
      link.click();
      link.remove();
      setShowSuccessDownloadTemplate(true);
    } catch (err) {
      console.error('Error while downloading template:', err);
    }
  };

  const handleDownloadContacts = async () => {
    try {
      const response = await getContactsData();
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: 'application/octect-stream' })
      );
      const link = document.createElement('a');
      link.href = url;
      link.download = 'Contacts_data.xlsx';
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      setShowSuccessContactsData(true);
    } catch (err) {
      console.error('Error while downloading data:', err);
    }
  };

  const validateData = async (contactData) => {
    const validObjects = [];
    const errorObjects = [];
    try {
      setIsLoading(true);
      for (let i = 0; i < contactData.length; i++) {
        const contact = contactData[i];
        const response = await fetch(
          `${window.REACT_APP_SERVER_URL}${
            window.API_V1
          }/cli/contacts/${cusNavId}/validateContact?login=${encodeURIComponent(mail)}`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${authToken}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(contact),
          }
        );
        const responseData = await response.json();
        if (responseData.data === false) {
          errorObjects.push({
            contact,
            error: responseData.errors,
          });
        } else {
          validObjects.push(contact);
        }
      }
      setErrors(errorObjects);
      setParsedData(validObjects);
    } catch (err) {
      console.error('validateData ---> err:', err);
    } finally {
      setIsLoading(false);
    }
  };

  const uploadFile = () => {
    setOnUploadingFile(true);
  };

  const onClose = () => {
    onCloseContactsImportModal(false);
  };

  const onCancelUploadFile = () => {
    setOnUploadingFile(false);
    setSelectedFileName('');
    setFile(null);
  };

  const onCancelValidation = () => {
    setParsedData([]);
    setErrors([]);
    setOnValidation(false);
    setSelectedFileName('');
    setFile(null);
  };

  const showErrorsInfo = () => {
    setErrorsInfo(true);
    setOnValidation(false);
  };

  const onCloseErrorsInfo = () => {
    setErrorsInfo(false);
    setOnValidation(true);
  };

  const handleDelete = (e) => {
    e.preventDefault();
    if (inputFileValue.current) {
      inputFileValue.current.value = '';
    }
    setSelectedFileName('');
    setFile(null);
  };

  const convertObject = (input) => {
    const output = [];

    input.forEach((obj) => {
      const tipoOrganizacion = obj['Tipo de organización [Persona fisica(Sí/No)]']?.toLowerCase();
      const typeOrg = tipoOrganizacion == 'si' || tipoOrganizacion == 'sí' ? '1' : '2';
      const sincronizarClientlink = obj['Sincronizar clientlink (Sí/No)']?.toLowerCase();

      output.push({
        clientI18: 'es-ES',
        clientName: obj['Razón social'],
        cif: obj.CIF,
        logo: null,
        typeOrganization: typeOrg || '',
        contactPhone: obj['Teléfono'],
        direction: obj['Dirección'],
        cp: obj.CP,
        state: obj.Provincia,
        local: obj.Localidad,
        contacts: [
          {
            name: obj.Nombre,
            surname: obj['Apellidos 1'],
            surnameTwo: obj['Apellidos 2'],
            phone: obj['Teléfono contacto'],
            syncClientlink: sincronizarClientlink === ('si' || 'sí'),
            mail: obj.Email,
            description: '',
            i18: 'es-ES',
            isAccess: false,
            domain: 'https://gks-dev.portaldecliente.es',
            isBD: false,
          },
        ],
      });
    });

    return output;
  };

  const handleFileChange = async (e) => {
    setError('');
    const newfile = e.target.files[0];
    setSelectedFileName(newfile?.name);
    if (e.target.files.length) {
      const inputFile = e.target.files[0];
      setFile(inputFile);
      const fileExtension = inputFile?.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        setError(t('input_file_xlsx_error_message'));
      }
    }
  };

  const handleParse = () => {
    setOnUploadingFile(false);
    setOnValidation(true);
    try {
      if (!file) {
        setError(t('input_file_xlsx_error_message'));
        return;
      }
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: 'binary' });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const jsonData = XLSX.utils.sheet_to_json(ws, { header: 1 });
        const headers = jsonData[0];
        const objects = jsonData.slice(1).map((row) => {
          const obj = {};
          headers.forEach((header, index) => {
            obj[header] = row[index];
          });
          return obj;
        });

        const requiredHeaders = [
          'Razón social',
          'CIF',
          'Tipo de organización [Persona fisica(Sí/No)]',
          'Teléfono',
          'Dirección',
          'CP',
          'Localidad',
          'Provincia',
          'Nombre',
          'Apellidos 1',
          'Apellidos 2',
          'Teléfono contacto',
          'Email',
          'Sincronizar clientlink (Sí/No)',
        ];

        if (requiredHeaders.every((header) => headers.includes(header))) {
          validateData(convertObject(objects));
        } else {
          setShowErrorInvalidData(true);
          onCancelValidation();
        }
      };

      reader.readAsBinaryString(file);
    } catch (err) {
      console.error('handleParse ---> error:', err);
    }
  };

  const importContacts = async (contactData) => {
    const res = [];
    try {
      setIsLoading(true);
      for (let i = 0; i < contactData.length; i++) {
        const contact = contactData[i];
        const response = await fetch(
          `${window.REACT_APP_SERVER_URL}${
            window.API_V1
          }/cli/Contacts/${cusNavId}/importContact?login=${encodeURIComponent(mail)}`,
          {
            method: 'POST',
            headers: {
              Authorization: `Bearer ${authToken}`,
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(contact),
          }
        );
        const responseData = await response.json();
        res.push(responseData);
      }
      for (let i = 0; i < res.length; i++) {
        if (res[i].errors.length > 0) {
          setShowErrorImportContactsData(true);
        } else {
          setShowSuccessImportContactsData(true);
        }
      }
      setIsLoading(false);
      setOnValidation(false);
      setParsedData([]);
      setErrors([]);
      setSelectedFileName('');
      setFile(null);
      if (inputFileValue.current) {
        inputFileValue.current.value = '';
      }
    } catch (err) {
      console.error('validateData ---> err:', err);
    }
  };

  const getErrorMessage = (errorCode) => {
    const errorMessages = {
      'CCCO-17': t('error_message_validation_import_contact'),
      'CCCOV-01': t('error_message_validation_no_access'),
      'CCCOV-02': t('error_message_validation_contact'),
      'CCCOV-03': t('error_message_validation_client_contact'),
      'CCCOV-04': t('error_message_validation_data_incomplete'),
      'CCCOV-05': t('error_message_validation_name_is_required'),
      'CCCOV-06': t('error_message_validation_cif_invalid'),
      'CCCOV-07': t('error_message_validation_email_invalid'),
      'CCCOV-08': t('error_message_validation_email_exist'),
      'CCCOV-09': t('error_message_validation_organization_type_invalid'),
    };
    return errorMessages[errorCode] || t('contacts_validation_error_message');
  };

  return (
    <div>
      <h2 className="title-modal-contacts">
        {!onUploadingFile && !errorsInfo
          ? t('general_migration_data_title')
          : t('general_import_data_title')}
      </h2>
      <hr className="dividing-line" />
      {!onUploadingFile && !onValidation && !errorsInfo && (
        <>
          <div className="button-section">
            <div className="styled-button" onClick={onDownloadTemplate}>
              <h3 className="button-title">{t('template_download_text')}</h3>
              <DownloadIcon className="button-icon" />
              <hr className="dividing-line-block" />
              <span className="button-description">{t('template_download_description')}</span>
            </div>
            <div className="styled-button" onClick={handleDownloadContacts}>
              <h3 className="button-title">{t('general_export')}</h3>
              <SendIcon className="button-icon" />
              <hr className="dividing-line-block" />
              <span className="button-description">{t('export_description')}</span>
            </div>
            <div className="styled-button" onClick={uploadFile}>
              <h3 className="button-title">{t('general_import')}</h3>
              <UploadIcon className="button-icon" />
              <hr className="dividing-line-block" />
              <span className="button-description">{t('import_description')}</span>
            </div>
          </div>
          <Button
            className="home__btn text-uppercase"
            type="button"
            label={t('general_close')}
            color="primary"
            onClick={onClose}
          />
        </>
      )}
      {onUploadingFile && (
        <div className="upload-file-section">
          <div className="input-file-div">
            <input
              ref={inputFileValue}
              onChange={handleFileChange}
              id="csvInput"
              name="file"
              type="File"
              accept=".xlsx"
            />
            <label htmlFor="csvInput" className="input-file">
              <div className="input-header">
                <span className="input-title">
                  {t('general_text_attach_xlsx')} <span className="error-text">*</span>
                </span>{' '}
                <UploadIcon className="input-icon" />
              </div>

              {selectedFileName && (
                <div className="input-header">
                  <span className="file-name">{selectedFileName}</span>
                  <button type="button" className="delete-button" onClick={handleDelete}>
                    <ErrorIcon fill={colors.suvaGrey} className="input-icon" />
                  </button>
                </div>
              )}
            </label>
          </div>
          {error && <LabelError label={error} />}
          <div className="button-section2">
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('general_button_cancel')}
              color="secondary"
              onClick={onCancelUploadFile}
            />
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('general_button_analize_file')}
              color="primary"
              onClick={handleParse}
              disabled={!file}
            />
          </div>
        </div>
      )}
      {onValidation && (
        <>
          {isLoading && <MainSpinner />}
          <div className="statistic-section">
            <div className="styled-statistic">
              <h3 className="statistic-title ">{t('general_total')}</h3>
              <hr className="dividing-line-statistic" />
              <p className="statistic-item">{parsedData.length + errors.length}</p>
              <hr className="dividing-line-statistic" />
              <ContactsIcon fill={colors.black} className="statistic-icon" />
            </div>
            <div className="styled-statistic">
              <h3 className="statistic-title">{t('general_valid')}</h3>
              <hr className="dividing-line-statistic" />
              <p className="statistic-item">{parsedData.length}</p>
              <hr className="dividing-line-statistic" />
              <ValidIcon fill={colors.pastelGreen} className="statistic-icon" />
            </div>
            <div className="styled-statistic">
              <h3 className="statistic-title">{t('general_error')}</h3>
              <hr className="dividing-line-statistic" />
              <p className="statistic-item">{errors.length}</p>
              <hr className="dividing-line-statistic" />
              <ErrorIcon fill={colors.venetianRed} className="statistic-icon" />
              {errors.length > 0 && (
                <button type="button" className="error-info" onClick={showErrorsInfo}>
                  {t('general_error_info')}
                </button>
              )}
            </div>
          </div>
          <div className="button-section2">
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('general_button_cancel')}
              color="secondary"
              onClick={onCancelValidation}
            />
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('general_previous')}
              color="secondary"
              onClick={onCancelValidation}
            />
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('general_import')}
              color="primary"
              onClick={() => importContacts(parsedData)}
              disabled={parsedData.length <= 0}
            />
          </div>
        </>
      )}
      {errorsInfo && errors.length && (
        <div className="error-list-main">
          <div className="error-list-header-div">
            <h3 className="error-list-header">{t('error_validation_data_list')}</h3>
            <h3 className="error-list-header">{errors.length}</h3>
          </div>
          <div>
            <Scrollbars style={{ height: '200px' }}>
              <ul className="ul-error-list">
                {errors.map((er) => (
                  <li className="error-list-item">
                    <div className="df">
                      <UserIcon fill={colors.suvaGrey} className="user-icon" />
                      <p className="error-list-item-title">{er.contact.clientName}</p>
                    </div>
                    <div className="df w-40">
                      {er.error.map((el) => (
                        <p className="error-list-item-title">
                          <span className="error-text">{t('general_validation_error')}</span>
                          {getErrorMessage(el.code)}
                        </p>
                      ))}
                    </div>
                  </li>
                ))}
              </ul>
            </Scrollbars>
          </div>
          <div className="button-section2">
            <Button
              className="home__btn text-uppercase"
              type="button"
              label={t('general_return')}
              color="primary"
              onClick={onCloseErrorsInfo}
            />
          </div>
        </div>
      )}
      <AlertModal
        type="success"
        isOpen={showSuccessDownloadTemplate}
        toggle={() => setShowSuccessDownloadTemplate(false)}
        message={t('template_download_success_message')}
        okText={t('general_button_ok')}
        onOk={() => setShowSuccessDownloadTemplate(false)}
      />
      <AlertModal
        type="success"
        isOpen={showSuccessContactsData}
        toggle={() => setShowSuccessContactsData(false)}
        message={t('contacts_data_download_success_message')}
        okText={t('general_button_ok')}
        onOk={() => setShowSuccessContactsData(false)}
      />
      <AlertModal
        type="success"
        isOpen={showSuccessImportContactsData}
        toggle={() => setShowSuccessImportContactsData(false)}
        message={t('contacts_import_success_message')}
        okText={t('general_button_ok')}
        onOk={() => setShowSuccessImportContactsData(false)}
      />
      <AlertModal
        type="error"
        isOpen={showErrorImportContactsData}
        toggle={() => setShowErrorImportContactsData(false)}
        message={t('contacts_import_error_message')}
        okText={t('general_button_ok')}
        onOk={() => setShowErrorImportContactsData(false)}
      />
      <AlertModal
        type="error"
        isOpen={showErrorInvalidData}
        toggle={() => setShowErrorInvalidData(false)}
        message={t('error_invalid_document_format')}
        okText={t('general_button_ok')}
        onOk={() => setShowErrorInvalidData(false)}
      />
      {loading && <MainSpinner />}
    </div>
  );
};

ContactsImportModal.propTypes = {
  onCloseContactsImportModal: PropTypes.func.isRequired,
};

export default ContactsImportModal;
